import { ParamsStore } from '@context/params';
import { ReleaseStatus } from '@graphql/reactQuery';

export const AVAILABILITY = {
  [ReleaseStatus.AvailableToMint]: 'Available',
  [ReleaseStatus.SoldOut]: 'Sold Out',
  [ReleaseStatus.Upcoming]: 'Upcoming',
} as const;

export const getDisplayValueFromSortType = ({ isTablet }: { isTablet: boolean }) => {
  if (ParamsStore.total_volume === 'DESC' || ParamsStore.total_volume === 'DESC') {
    return isTablet ? 'Volume (High to Low)' : 'Volume';
  } else if (ParamsStore.artists_backed === 'DESC') {
    return isTablet ? 'Artists Backed (High to Low)' : 'Artists Backed';
  } else if (
    ParamsStore.mint_start_time === 'DESC' ||
    ParamsStore.created_at === 'DESC' ||
    ParamsStore.first_nft_collected_date === 'DESC'
  ) {
    return 'Newest';
  } else if (
    ParamsStore.mint_start_time === 'ASC' ||
    ParamsStore.created_at === 'ASC' ||
    ParamsStore.first_nft_collected_date === 'ASC'
  ) {
    return 'Oldest';
  } else if (ParamsStore.num_referral_purchases === 'DESC') {
    return isTablet ? 'Mints Driven (High to Low)' : 'Mints Driven';
  }

  return isTablet ? 'Mints (High to Low)' : 'Mints';
};

export const getDefaultSortTypes = ({ isTablet }: { isTablet: boolean }) => {
  return isTablet
    ? ['Volume (High to Low)', 'Mints (High to Low)', 'Newest', 'Oldest']
    : ['Volume', 'Mints', 'Newest', 'Oldest'];
};

export const getCollectorsSortType = ({ isTablet }: { isTablet: boolean }) => {
  return isTablet
    ? ['Volume (High to Low)', 'Mints (High to Low)', 'Artists Backed (High to Low)']
    : ['Volume', 'Mints', 'Artists Backed'];
};

export const getPlaylistsSortType = ({ isTablet }: { isTablet: boolean }) => {
  return isTablet
    ? ['Mints Driven (High to Low)', 'Newest', 'Oldest']
    : ['Mints Driven', 'Newest', 'Oldest'];
};

export const getCollectionSortTypes = ({ isTablet }: { isTablet: boolean }) => {
  return isTablet ? ['Mints (High to Low)', 'Newest', 'Oldest'] : ['Mints', 'Newest', 'Oldest'];
};
